import { render } from "./UpdateUser.vue?vue&type=template&id=4e6b8e6c&scoped=true"
import script from "./UpdateUser.vue?vue&type=script&lang=js"
export * from "./UpdateUser.vue?vue&type=script&lang=js"

import "./UpdateUser.vue?vue&type=style&index=0&id=4e6b8e6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6b8e6c"]])

export default __exports__